import React from 'react';
import useStyles from './useStyles';
import CommentRatingStar from '../CommentRatingStar';
import RatingRatio from './RatingRatio';

import { CustomizedTypography } from '@components/Customized';

import { clsx, colorSet } from '@components/Provider';
import { StarFilled } from '@carbon/icons-react';
import { formatCurrency } from '@utils/formatter';
import { CapaReviewPointRatio } from '@generated/graphql';

interface Props {
  avgPoint: number;
  count: number;
  pointRatio: Omit<CapaReviewPointRatio, '__typename'>;
}
const ReviewRatingPresenter = ({ avgPoint, count, pointRatio }: Props) => {
  const classes = useStyles();

  const ratioToPercent = (ratio: number) => {
    return (ratio / count) * 100;
  };

  return (
    <div className={classes.container}>
      <div className={classes.title}>
        <StarFilled color={colorSet.primary500} size={20} />
        <CustomizedTypography
          variant="subtitle1"
          color="textPrimary"
          fontWeight="bold"
        >
          {avgPoint.toFixed(1)} · 리뷰 ({formatCurrency(count)}개)
        </CustomizedTypography>
      </div>

      <div className={classes.contents}>
        <div className={classes.half}>
          <CustomizedTypography
            variant="body2"
            color="textPrimary"
            fontWeight="500"
            gutterBottoms={4}
          >
            고객 총 평점
          </CustomizedTypography>
          <div className="inner_box">
            <CustomizedTypography
              className="rating"
              variant="h2"
              color="textPrimary"
              fontWeight="bold"
            >
              {avgPoint.toFixed(1)}
              <span className="divider">/</span>
              <span className="max">5</span>
            </CustomizedTypography>
            <CommentRatingStar rating={Math.floor(avgPoint)} />
            <CustomizedTypography variant="caption" color="textSecondary">
              ({formatCurrency(count)}개)
            </CustomizedTypography>
          </div>
        </div>
        <div className={classes.half}>
          <CustomizedTypography
            variant="body2"
            color="textPrimary"
            fontWeight="500"
            gutterBottoms={4}
          >
            평점 비율
          </CustomizedTypography>
          <div className={clsx('inner_box', 'ratios')}>
            {Object.keys(pointRatio).map((key) => (
              <RatingRatio
                key={key}
                label={key as keyof typeof pointRatio}
                ratio={ratioToPercent(
                  pointRatio[key as keyof typeof pointRatio]
                )}
                count={key === 'five' ? pointRatio?.five : undefined}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewRatingPresenter;
